import { X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { ReportColumn } from "@/types/evaluate";

interface FullscreenDialogHeaderProps {
  column: ReportColumn;
  onClose: () => void;
  viewMode?: "normal" | "raw";
}

export const FullscreenDialogHeader = ({
  column,
  onClose,
  viewMode = "normal",
}: FullscreenDialogHeaderProps) => (
  <div className="flex h-14 items-center justify-between gap-x-2 border-b bg-background px-4 py-3">
    <h2 className="text-lg font-semibold">
      {column.name}
      {viewMode === "raw" && (
        <span className="ml-2 text-sm font-normal text-muted-foreground">(Raw object)</span>
      )}
    </h2>
    <Button
      variant="ghost"
      size="icon"
      onClick={onClose}
      className="h-8 w-8 rounded-full hover:bg-muted"
    >
      <X className="h-4 w-4" />
      <span className="sr-only">Close fullscreen</span>
    </Button>
  </div>
);
